var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 12.5,
    fill: "white",
    stroke: "#FF754C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8789 30L30 27.8789L23.1211 21L30 14.1211L27.8789 12L21 18.8789L14.1211 12L12 14.1211L18.8789 21L12 27.8789L14.1211 30L21 23.1211L27.8789 30Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCancel);
export default __webpack_public_path__ + "static/media/header-cancel.1166a0a2acaf69278cc7f48588b73b3b.svg";
export { ForwardRef as ReactComponent };